<template>
  <v-snackbar
      bottom left
      v-model="show"
      :timeout="-1"
  >
    <v-progress-circular v-model="porcentajeDescarga" :indeterminate="!totalDescarga" />
    <slot>
      Descargando
    </slot>
  </v-snackbar>
</template>

<script>
  export default {
    name: "DownloadSnackbar",
    props: {
      progresoDescarga: {
        type: Number,
        default: () => null
      },
      totalDescarga: {
        type: Number,
        default: () => null
      },
      value: {
        type: Boolean,
        default: () => false,
      },
    },
    data: () => ({
      show: false,
    }),
    watch: {
      value(val) {
        this.show = val;
      },
    },
    computed: {
      porcentajeDescarga () {
        return this.progresoDescarga !== null && this.totalDescarga !== null
          ? this.progresoDescarga / this.totalDescarga : 0;
      },
    },
  }
</script>

<style scoped>

</style>
